require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-sheahan-townhouses.json") })
        }
      }, "path---news-sheahan-townhouses");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-sheahan-townhouses!./.cache/json/news-sheahan-townhouses.json
// module id = 846
// module chunks = 231608221292675